import axios from 'axios';
import toaxios from 'src/utils/axios';
import qs from 'qs';
import { API_BASE, requests,VERSION_APP,SYSTEM,LOGIN } from '../constants/config';

export const SESSION_LOGIN_REQUEST = 'SESSION_LOGIN_REQUEST';
export const SESSION_LOGIN_SUCCESS = 'SESSION_LOGIN_SUCCESS';
export const SESSION_LOGIN_FAIL = 'SESSION_LOGIN_FAIL';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SESSION_CREDENTIALS = 'SESSION_CREDENTIALS';
export const SESSION_SET_TOKEN = 'SESSION_SET_TOKEN';
export const SESSION_SET_VENDOR_ID = 'SET_VENDOR_ID';

export const login = (formState) => async (dispatch) => {
    dispatch({ type: SESSION_LOGIN_REQUEST });

    let dataLogin = qs.stringify({
        'username': formState.email,
        'password': formState.password,
        'grant_type': 'password'
    });

    const config = {
        method: 'post',
        url: API_BASE + requests.token,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic aW50ZWdyYTpzZWNyZXQ='
        },
        data: dataLogin
    };

    try {
        const { data } = await axios(config);
        dispatch({ type: SESSION_SET_TOKEN, payload: data });
        localStorage.setItem('token', JSON.stringify(data));
        localStorage.setItem('user', JSON.stringify({ 'username': formState.email, 'password': formState.password }));
        localStorage.setItem('loggedIn', true);
        toaxios.defaults.headers.common['Authorization'] = `Bearer ${data.access_token}`;
        dispatch(userInfo(formState));
        dispatch({ type: SESSION_LOGIN_SUCCESS, payload: data });
        
    } catch (error) {
        dispatch({
            type: SESSION_LOGIN_FAIL,
            payload: error.response && error.response.data.error_description
                ? error.response.data.error_description
                : 'Ocurrió un error'
        });
    }
};

export const userInfo = (formState) => async (dispatch) => {
    const config = {
        method: 'post',
        url: requests.userData,
        data: {
            'username': formState.email,
            'password': formState.password
        }
    };
    await toaxios(config)
        .then(function(response) {           
            localStorage.setItem('user', JSON.stringify(response.data));
            localStorage.setItem('selectedVendorId', JSON.stringify(response.data.numpro));
            dispatch(setVendorIdA(response.data.numpro));
            dispatch({ type: SESSION_CREDENTIALS, payload: response.data });
            dispatch(logInOutl(response.data.userId));
        })
        .catch(function(error) {
        });
};

export const setVendorIdA = (id) => (dispatch) => {
    //console.log("Ree.."+id);
    localStorage.setItem('selectedVendorId', id);
    dispatch({
        type: SESSION_SET_VENDOR_ID,
        payload: id
    });
};

export const logout = () => (dispatch) => {
   // console.log("CERRAR::"+localStorage.getItem('user').correo);
   //const user = JSON.parse(localStorage.getItem('user'));
   localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('vendorData');
    localStorage.removeItem('companyNames');
    localStorage.removeItem('selectedVendorId');
    dispatch({ type: SESSION_LOGOUT });
    document.location.href = '/auth/login';
};

export const logInOutl = (userId) => async (dispatch) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const config = {
        method: 'post',
        url: requests.logInOut,
        data: {
            'p_logins_id':userId,
                'operacion': LOGIN,
                'sistema':SYSTEM,
                'version': VERSION_APP
        }
    };
    await axios(config)
        .then(function(response) {
            console.log("Response"+response);
        })
        .catch(function(error) {
        });
};
